import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Salary } from '@/components/salary-metadata';
import { JobSalary } from '@/graphql/generated';

import { useHeaderContext } from '../../context';

export const FormattedSalary: React.FC<{ salary: JobSalary }> = ({ salary }) => {
  const { isSalaryEstimate } = useHeaderContext();
  return (
    <>
      <Salary salary={salary} />
      {isSalaryEstimate && (
        <>
          &nbsp;
          <FormattedMessage id="JOBS_JOB_DETAIL_SALARY_XING_ESTIMATED" />
        </>
      )}
    </>
  );
};
